import type { ScheduleDefaultsType } from '@elfsight/widget-conditional-display';
import { buildBasicRRule } from './build-basic-rrule';
import { buildCustomRRule } from './build-custom-rrule';

export const buildRRule = (schedule: ScheduleDefaultsType, start: Date) => {
  const { scheduleRepeatPeriod } = schedule;

  if (scheduleRepeatPeriod === 'noRepeat') {
    return;
  }

  const parts =
    scheduleRepeatPeriod === 'custom'
      ? buildCustomRRule(schedule, start)
      : buildBasicRRule(scheduleRepeatPeriod, start);

  return `RRULE:${parts.join(';')}` as const;
};
